import { CategoryQuestions } from '../types';

export const massageQuestions: CategoryQuestions = {
  title: 'Personalize Your Massage Session',
  questions: {
    preferredStyle: {
      label: 'What type of massage guidance do you prefer?',
      type: 'radio',
      options: ['Step-by-step technique instructions', 'Relaxation narration only', 'Music with minimal talking', 'Complete silence with gentle cues']
    },
    primaryGoal: {
      label: 'What are you hoping to achieve with this massage?',
      type: 'radio',
      options: ['Muscle tension relief', 'Full body relaxation', 'Stress release', 'Better sleep preparation']
    },
    specificFocus: {
      label: 'Where in your body feels tense or sore?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  // Practitioner perspective questions
  practitionerTitle: 'Personalize Massage Session for Your Client',
  practitionerQuestions: {
    preferredStyle: {
      label: 'What type of massage guidance does your client prefer?',
      type: 'radio',
      options: ['Step-by-step technique instructions', 'Relaxation narration only', 'Music with minimal talking', 'Complete silence with gentle cues']
    },
    primaryGoal: {
      label: 'What is your client hoping to achieve with this massage?',
      type: 'radio',
      options: ['Muscle tension relief', 'Full body relaxation', 'Stress release', 'Better sleep preparation']
    },
    specificFocus: {
      label: 'Where in your client\'s body feels tense or sore?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerGroupTitle: 'Personalize Massage Session for Your Clients',
  practitionerGroupQuestions: {
    preferredStyle: {
      label: 'What type of massage guidance do your clients prefer?',
      type: 'radio',
      options: ['Step-by-step technique instructions', 'Relaxation narration only', 'Music with minimal talking', 'Complete silence with gentle cues']
    },
    primaryGoal: {
      label: 'What are your clients hoping to achieve with this massage?',
      type: 'radio',
      options: ['Muscle tension relief', 'Full body relaxation', 'Stress release', 'Better sleep preparation']
    },
    specificFocus: {
      label: 'Where in your clients\' bodies feels tense or sore?',
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  groupTitle: 'Personalize Your Group Massage Session',
  groupQuestions: {
    massageGroupType: {
      label: 'What type of group massage session are you creating?',
      type: 'radio',
      options: ['Couples massage guidance', 'Family relaxation session', 'Friends spa experience', 'Team building massage activity', 'Self-massage workshop', 'Partner massage instruction']
    },
    groupMassageStyle: {
      label: 'What approach works best for your group massage?',
      type: 'radio',
      options: ['Everyone doing self-massage together', 'Partner massage with guidance', 'Taking turns giving/receiving', 'Synchronized group movements', 'Individual practice in group setting']
    },
    experienceLevels: {
      label: 'What are the massage experience levels in your group?',
      type: 'radio',
      options: ['All beginners - need detailed instruction', 'Mixed experience levels', 'Most experienced - minimal guidance needed', 'Professional training setting']
    },
    groupComfortLevel: {
      label: 'What is the comfort level for physical touch in your group?',
      type: 'radio',
      options: ['Very comfortable with partner massage', 'Comfortable with guided touch', 'Prefer self-massage only', 'Mixed comfort levels - accommodate all']
    },
    sharedTensionAreas: {
      label: 'What areas of tension or stress does your group want to address?',
      type: 'textarea',
      placeholder: 'Describe common problem areas, shared physical stress, or group tension points...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  giftTitle: 'Personalize Massage Session for Your Loved One',
  giftQuestions: {
    massageType: {
      label: 'What type of massage experience would they enjoy most?',
      type: 'radio',
      options: ['Deep tissue relaxation', 'Gentle stress relief', 'Self-massage guidance', 'Partner massage instructions']
    },
    focusAreas: {
      label: 'What areas carry the most tension for them?',
      type: 'radio',
      options: ['Neck and shoulders', 'Back and spine', 'Hands and feet', 'Full body', 'Head and face']
    },
    specificNeeds: {
      label: 'Any specific tension areas or needs?',
      type: 'textarea',
      placeholder: 'Describe their specific tension points or massage preferences...'
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  }
};
